export default 'release' // debug | release | testing
